import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper";
import { useEffect, useState } from "react";

const testimonial_data = [
    {
        img: '/assets/images/testimonial/testimonial-01.png',
        desc: 'Kararlı bir şekilde hareket etmenizi sağlıyor. ' +
            'Tam da gerçek hayatta ihtiyacım olan bilgileri edindim. Bu bilgiler yeni bir rol ' +
            'için yetkinliklerimi sergilememe yardımcı oldu.',
        ratings: <>
            <i className="icon-23"></i>
            <i className="icon-23"></i>
            <i className="icon-23"></i>
            <i className="icon-23"></i>
            <i className="icon-23"></i>
        </>,
        name: 'İrfan Muğultay',
        title: 'Öğrenci'
    },
    {
        img: '/assets/images/testimonial/testimonial-02.png',
        desc: 'Platformdaki kursların kalitesi gerçekten mükemmel. ' +
            'Eğitmenler alanında uzman ve her ders keyifli bir öğrenme deneyimi sunuyor. Kendi hızınızda öğrenmek harika!',
        ratings: <>
            <i className="icon-23"></i>
            <i className="icon-23"></i>
            <i className="icon-23"></i>
            <i className="icon-23"></i>
            <i className="icon-23"></i>
        </>,
        name: 'Ferdi Atalay',
        title: 'Öğrenci'
    },
    {
        img: '/assets/images/testimonial/testimonial-03.png',
        desc: 'Başlangıç seviyesinden ileri düzeye kadar geniş bir kurs yelpazesi sunması, ' +
            'herkesin ihtiyaçlarına hitap ediyor. Öğrenmek istediğim her şeyi burada bulabiliyorum!',
        ratings: <>
            <i className="icon-23"></i>
            <i className="icon-23"></i>
            <i className="icon-23"></i>
            <i className="icon-23"></i>
            <i className="icon-23"></i>
        </>,
        name: 'Hüseyin Dağlı',
        title: 'Öğrenci'
    },
    {
        img: '/assets/images/testimonial/testimonial-04.png',
        desc: 'Kurslar sadece teorik bilgi sunmakla kalmıyor, ' +
            'aynı zamanda gerçek hayatta uygulayabileceğiniz pratik bilgiler de veriyor. Bu, öğrenmeyi çok daha anlamlı kılıyor!',
        ratings: <>
            <i className="icon-23"></i>
            <i className="icon-23"></i>
            <i className="icon-23"></i>
            <i className="icon-23"></i>
            <i className="icon-23"></i>
        </>,
        name: 'Ali Deniz',
        title: 'Öğrenci'
    }
]

export default function TestimonialArea() {
    const [loop,setLoop] = useState(false);
    useEffect(() => setLoop(true) ,[])
    return (
        <div className="testimonial-area-1 section-gap-equal">
            <div className="container">
                <div className="row g-lg-5">
                    <div className="col-lg-5">
                        <div className="testimonial-heading-area">
                            <div className="section-title section-left" data-sal-delay="50" data-sal="slide-up" data-sal-duration="800">
                                <h2 className="title">Öğrencilerimizin Söyledikleri</h2>
                                <span className="shape-line"><i className="icon-19"></i></span>
                                <p>Diğer öğrencilerin öğrenim yoluyla başardıklarına göz atın.</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <Swiper
                            slidesPerView={1}
                            spaceBetween={0}
                            loop={loop}
                            className="home-one-testimonial-activator swiper "
                            modules={[Autoplay]}
                            pagination={false}
                            grabCursor={true}
                            speed={1500}
                            autoplay={{
                                delay: 3500
                            }}
                            breakpoints={{
                                577: {
                                slidesPerView: 2
                                }
                            }}
                        >
                            {testimonial_data.map((testi, i) => (
                                <SwiperSlide key={i}>
                                    <div className="testimonial-grid">
                                        <div className="thumbnail">
                                            <img src={testi.img} alt="Testimonial" />
                                            <span className="qoute-icon"><i className="icon-26"></i></span>
                                        </div>
                                        <div className="content">
                                            <p>{testi.desc}</p>
                                            <div className="rating-icon">
                                                {testi.ratings}
                                            </div>
                                            <h5 className="title">{testi.name}</h5>
                                            <span className="subtitle">{testi.title}</span>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </div>
            </div>
        </div>
    )
}
